var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-default-app-bar',{attrs:{"back-to":_vm.backToValueRoute}},[_c('div',[_vm._v(" "+_vm._s(`Leitor QR-Code`)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }